import { Injectable } from '@angular/core';
import {HttpClient,HttpParams, HttpErrorResponse} from '@angular/common/http'
import {BehaviorSubject, forkJoin, throwError, Observable,of, combineLatest} from 'rxjs';
import { catchError,startWith, debounceTime, delay, map, switchMap } from 'rxjs/operators';

import {Router} from '@angular/router';
import { environment, } from '../../../../environments/environment';
import { FormGroup } from '@angular/forms';
import { InventoyDataList } from '../../../shared/models/models';

@Injectable({
  providedIn: 'root'
})
export class InventoryService {

  private AddInventoryUrl = `${environment.TataapiUri}/api/v1/inventory/addInventory/`;
//   private InventoryListUrl = `${environment.TataapiUri}/api/v1/inventory/inventoryList/`;
private InventoryListUrl = `${environment.TataapiUri}/api/v2/inventory/list_inventory/`;
private InventoryListUrl1 = `${environment.TataapiUri}/api/v1/inventory/inventoryList/`;
  private ApproveInventoryUrl = `${environment.TataapiUri}/api/v1/auction/approve_inventory/`;
  
  private ViewInventoryByIdUrl = `${environment.TataapiUri}/api/v1/auction/view_inventory/`;
   private EditInventoryUrl = `${environment.TataapiUri}/api/v1/auction/edit_single_inventory/`;
   private RemoveInventoryUrl = `${environment.TataapiUri}/api/v1/auction/delete_file/`;
 
   private UploadVideoUrl = `${environment.TataapiUri}/api/v1/inventory/upload_video/`; 
   private ViewInventoryByIdUrlTSM = `${environment.TataapiUri}/api/v2/inventory/view_inventory/`;

  constructor(private http:HttpClient,private _Router:Router) { }

  AddInventory(data:any):Observable<any>
  {
     return this.http.post<any>(this.AddInventoryUrl,data).pipe(catchError(this.handlError));
  }
  InventoryList(data:any):Observable<any>
  {
     return this.http.post<any>(this.InventoryListUrl,data).pipe(catchError(this.handlError));
  }
  ApproveInventory(data:any):Observable<any>
  {
     return this.http.post<any>(this.ApproveInventoryUrl,data).pipe(catchError(this.handlError));
  }

  ViewInventoryById(data:any):Observable<any>
  {
     return this.http.post<any>(this.ViewInventoryByIdUrl,data).pipe(catchError(this.handlError));
  }

  UpdateInventoryById(data:any):Observable<any>
  {
     return this.http.post<any>(this.EditInventoryUrl,data).pipe(catchError(this.handlError));
  }

  RemoveInventoryById(data:any):Observable<any>
  {
     return this.http.post<any>(this.RemoveInventoryUrl,data).pipe(catchError(this.handlError));
  }

  UploadVideo(data:any):Observable<any>
  {
     return this.http.post<any>(this.UploadVideoUrl,data).pipe(catchError(this.handlError));
  }
  
  handlError(error:HttpErrorResponse)
  {
    return throwError(error)
  }
  ViewInventoryByIdtsm(data:any):Observable<any>
  {
     return this.http.post<any>(this.ViewInventoryByIdUrlTSM,data).pipe(catchError(this.handlError));
  }
  InventoryList1(data:any):Observable<any>
  {
     return this.http.post<any>(this.InventoryListUrl1,data).pipe(catchError(this.handlError));
  }
}
